import { observer } from 'mobx-react-lite'
import { AutomationLogResultStatusConfig } from 'entities/Integrations/ui/AutomationLogResultStatus'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations'
import type { IFilterValue, IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetAutomationLogResultStatus = observer(
  (
    props: IWidgetProps<
      IFilterValue<IAutomationLogExecutionStatus>,
      IAutomationLogExecutionStatus[]
    >
  ) => {
    return (
      <WidgetStatus
        getConfigByStatus={(status) =>
          AutomationLogResultStatusConfig({ failedReason: 'failedReason' })[status]
        }
        {...props}
      />
    )
  }
)
